module.exports = __webpack_public_path__ + "img/022-storm-21.c84be4ce.svg";